import { ModalForm } from '@ant-design/pro-form';
import { useNavigate } from 'react-router-dom';
import axiosApiInstance from '../../../api/axiosClient';
import { GlobalStateContext } from '../../../context/GlobalContext';
import { useContext, useState } from 'react';
import { Form } from 'antd';
import ConnectionFormFields, {
    applyPrimaryFlags,
    defaultPrimaryIndices,
    PrimaryIndices,
} from './ConnectionFormFields';
import CreatorLinkField, { CreatorLinkInfoAlert } from './CreatorLinkField';

const NewConnectionModal = () => {
    const navigate = useNavigate();
    const { contactsTableRef } = useContext(GlobalStateContext);
    const [form] = Form.useForm<API.CRM.Contact>();
    const [primaries, setPrimaries] = useState<PrimaryIndices>(defaultPrimaryIndices);
    const [linkedCreatorIds, setLinkedCreatorIds] = useState<number[]>([]);

    return (
        <ModalForm<API.CRM.Contact>
            title="Add Contact"
            autoFocusFirstInput
            open
            width={1000}
            form={form}
            modalProps={{
                onCancel: () => navigate('/social/connections'),
            }}
            onFinish={async (values: Partial<API.CRM.Contact>) => {
                const payload = {
                    ...applyPrimaryFlags(values, primaries),
                    linked_creator_ids: linkedCreatorIds,
                    linked_creators: linkedCreatorIds.map((id) => ({
                        id,
                        creator: '',
                    })),
                };
                await axiosApiInstance.post('/api/connections/contacts/', payload);
                contactsTableRef.current.reload();
                navigate('/social/connections');
            }}
        >
            <CreatorLinkInfoAlert />
            <CreatorLinkField value={linkedCreatorIds} onChange={setLinkedCreatorIds} />
            <ConnectionFormFields primaries={primaries} setPrimaries={setPrimaries} />
        </ModalForm>
    );
};

export default NewConnectionModal;
